<template>
  <div class="login-container" :style="loginBackground ? { backgroundImage: `url(${loginBackground})` } : {}">
    <Toast ref="toast" />
    <div class="login-box">
      <div class="login-header">
        <img v-if="systemLogo" :src="systemLogo" class="logo-img" alt="Logo" />
        <div v-else class="logo">LOGO</div>
        <span class="title">{{ systemName || '欢迎使用答题系统' }}</span>
      </div>
      <div class="login-form">
        <div class="form-item">
          <input type="text" v-model="form.account" placeholder="学号/邮箱" />
        </div>
        <div class="form-item">
          <input type="password" v-model="form.password" placeholder="密码" />
        </div>
        <div class="form-item captcha-item">
          <input type="text" v-model="form.code" placeholder="验证码" />
          <div class="captcha-box" @click="getCaptchaImage">
            <img v-if="captchaImg" :src="'data:image/gif;base64,' + captchaImg" alt="验证码" />
          </div>
        </div>
<!--        <div class="forgot-password">-->
<!--          <a href="#">忘记密码?</a>-->
<!--        </div>-->
        <button class="login-btn" @click="handleLogin">登录</button>
      </div>
    </div>
  </div>
</template>

<script>
import { login, getCaptcha } from '@/api/login'
import { getSystemConfig } from '@/api/systemConfig'
import Toast from '@/components/Toast.vue'

export default {
  name: 'LoginPage',
  components: { Toast },
  data() {
    return {
      form: {
        account: '',
        password: '',
        code: ''
      },
      uuid: '',
      captchaImg: '',
      captchaEnabled: true,
      loading: false,
      loginBackground: '',
      systemLogo: '',
      systemName: ''
    }
  },
  mounted() {
    this.getCaptchaImage()
    this.loadSystemConfig()
  },
  methods: {
    async loadSystemConfig() {
      try {
        const res = await getSystemConfig()
        if (res.data) {
          if (res.data.loginBackground) {
            this.loginBackground = res.data.loginBackground
          }
          if (res.data.systemLogo) {
            this.systemLogo = res.data.systemLogo
          }
          if (res.data.systemName) {
            this.systemName = res.data.systemName
          }
        }
      } catch (error) {
        console.error('获取系统配置失败', error)
      }
    },
    async getCaptchaImage() {
      try {
        const res = await getCaptcha()
        this.captchaEnabled = res.captchaEnabled === undefined ? true : res.captchaEnabled
        if (this.captchaEnabled) {
          this.uuid = res.uuid
          this.captchaImg = res.img
        }
      } catch (error) {
        console.error('获取验证码失败', error)
      }
    },
    async handleLogin() {
      // 表单验证
      if (!this.form.account) {
        this.$refs.toast.show('请输入学号/邮箱')
        return
      }
      if (!this.form.password) {
        this.$refs.toast.show('请输入密码')
        return
      }
      if (this.captchaEnabled && !this.form.code) {
        this.$refs.toast.show('请输入验证码')
        return
      }

      this.loading = true
      try {
        const res = await login({
          account: this.form.account,
          password: this.form.password,
          code: this.form.code,
          uuid: this.uuid
        })

        // 登录成功，保存用户信息到 localStorage
        // res 结构: {code: 200, msg: "登录成功", data: {userId, userName, token, ...}}
        const userData = res.data
        localStorage.setItem('token', userData.token)
        localStorage.setItem('userInfo', JSON.stringify(userData))

        this.$refs.toast.show({
          message: '登录成功',
          onConfirm: () => {
            this.$router.push('/home')
          }
        })
      } catch (error) {
        this.$refs.toast.show(error.message || '登录失败')
        this.getCaptchaImage()
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.login-container {
  width: 100vw;
  height: 100vh;
  background-image: url('@/assets/image/background.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 10%;
  box-sizing: border-box;
}

.login-box {
  width: 380px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 12px;
  padding: 40px 35px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.login-header {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

.logo {
  width: 45px;
  height: 45px;
  background: #3d8c40;
  border-radius: 8px;
  color: white;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}

.logo-img {
  width: 45px;
  height: 45px;
  border-radius: 8px;
  object-fit: contain;
  margin-right: 12px;
}

.title {
  font-size: 20px;
  color: #333;
  font-weight: 500;
}

.form-item {
  margin-bottom: 18px;
}

.form-item input {
  width: 100%;
  height: 45px;
  border: none;
  background: #e8e8e8;
  border-radius: 6px;
  padding: 0 15px;
  font-size: 14px;
  color: #333;
  box-sizing: border-box;
}

.form-item input::placeholder {
  color: #888;
}

.form-item input:focus {
  outline: none;
  background: #e0e0e0;
}

.captcha-item {
  display: flex;
  gap: 10px;
}

.captcha-item input {
  flex: 1;
}

.captcha-box {
  width: 120px;
  height: 45px;
  border-radius: 6px;
  cursor: pointer;
  background: #e8e8e8;
}

.captcha-box img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.forgot-password {
  text-align: right;
  margin-bottom: 20px;
}

.forgot-password a {
  color: #3d8c40;
  font-size: 13px;
  text-decoration: none;
}

.forgot-password a:hover {
  text-decoration: underline;
}

.login-btn {
  width: 100%;
  height: 48px;
  background: linear-gradient(135deg, #4a9d4e 0%, #3d8c40 100%);
  border: none;
  border-radius: 24px;
  color: white;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
}

.login-btn:hover {
  background: linear-gradient(135deg, #3d8c40 0%, #2e7d32 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(61, 140, 64, 0.4);
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .login-container {
    justify-content: center;
    padding: 20px;
  }

  .login-box {
    width: 100%;
    max-width: 380px;
    padding: 30px 25px;
  }

  .login-header {
    margin-bottom: 25px;
  }

  .logo {
    width: 40px;
    height: 40px;
  }

  .title {
    font-size: 18px;
  }

  .form-item input {
    height: 42px;
  }

  .login-btn {
    height: 44px;
    font-size: 15px;
  }
}
</style>
